import { shallowEqualObjects as _shallowEqualObjects, shallowEqualArrays as _shallowEqualArrays } from 'shallow-equal';
/**
 * 用于 React 的浅比较对象
 * @param a
 * @param b
 */
export function shallowEqualObjects(a, b) {
    return _shallowEqualObjects(a, b);
}
/**
 * 用于 React 的浅比较数组
 * @param a
 * @param b
 */
export function shallowEqualArrays(a, b) {
    return _shallowEqualArrays(a, b);
}
//# sourceMappingURL=shallow-equal.js.map